module.exports = __webpack_public_path__ + "img/empty.6b88aaf8.png";